import { 
  signOut,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithCustomToken
} from 'firebase/auth';
import { auth } from './config';

/**
 * Googleでログイン
 * TODO(ver2.1): providerはfirebase固定にしたい
 */
export const loginWithGooglePopup = async () => {
  try {
    const provider = new GoogleAuthProvider();

    // スコープの設定
    provider.addScope('email');
    provider.addScope('profile');

    // ポップアップ認証を開始
    const result = await signInWithPopup(auth, provider);
    console.log('Googleポップアップログイン成功:', result.user.email);

    return { user: result.user, provider: 'google', error: null };
  } catch (error) {
    console.error('Googleポップアップログインエラー:', error);
    return { user: null, provider: 'google', error: error.message };
  }
};

/**
 * Appleでログイン
 * TODO(ver2.1): providerはfirebase固定にしたい
 */
export const loginWithApplePopup = async () => {
  try {
    const provider = new OAuthProvider('apple.com');

    // スコープの設定
    provider.addScope('email');
    provider.addScope('name');

    // ポップアップ認証を開始
    const result = await signInWithPopup(auth, provider);
    console.log('Appleポップアップログイン成功:', result.user.email);

    return { user: result.user, provider: 'apple', error: null };
  } catch (error) {
    console.error('Appleポップアップログインエラー:', error);
    return { user: null, provider: 'apple', error: error.message };
  }
};

/**
 * カスタムトークンでログイン
 */
export const loginWithCustomToken = async (token) => {
  try {
    const result = await signInWithCustomToken(auth, token);
    console.log('カスタムトークンログイン成功:', result.user.email);

    return { user: result.user, error: null };

  } catch (error) {
    console.error('カスタムトークンログインエラー:', error);
    return { user: null, error: error.message };
  }
};

/**
 * ログアウト処理
 */
export const logout = async () => {
  try {

    if (!auth.currentUser) {
      return { error: null };
    }

    await signOut(auth);
    return { error: null };
  } catch (error) {
    console.error('Firebase auth.js: ログアウトエラー:', error);
    return { error: error.message };
  }
};

/**
 * 現在のユーザー状態をログ出力（デバッグ用）
 */
// export const debugAuthState = () => {
//   const user = auth.currentUser;
//   console.log('現在のFirebaseユーザー状態:', user ? {
//     uid: user.uid,
//     email: user.email,
//     displayName: user.displayName,
//     isAnonymous: user.isAnonymous,
//     emailVerified: user.emailVerified,
//     providerData: user.providerData,
//   } : 'ログインしていません');

//   return user;
// };